const NAVY = '#1B3A5C';
const CONTENT_GRAY = '#F2F2F2';
const SECTION_TITLE_GRAY = '#D8D8D8';
const SUBTITLE_GRAY = '#9AA0A6';
const TITLE_FONT = '"Costa Pro", Arial, Helvetica, sans-serif';

const styles = {
  container: {
    // Left-align like SQUAD (no mx:auto) so the preview sits tight against the config column.
    // Wider than A4-at-96dpi (794) so the editor uses more of the 960px right column.
    width: 900,
    maxWidth: '100%',
    minHeight: 1123,
    boxSizing: 'border-box' as const,
    mb: 3,
    p: '22px',
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: 2,
    position: 'relative' as const,
    overflow: 'hidden',
    fontFamily: 'Caladea, Georgia, "Times New Roman", serif',
    color: '#111',
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    pb: 12,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 4,
  },
  title: {
    fontFamily: TITLE_FONT,
    fontSize: '52px',
    fontWeight: 700,
    color: NAVY,
    lineHeight: 1.05,
    letterSpacing: '-0.01em',
  },
  subtitle: {
    fontFamily: TITLE_FONT,
    fontSize: '20px',
    fontWeight: 400,
    color: SUBTITLE_GRAY,
    lineHeight: 1.2,
    letterSpacing: '-0.01em',
  },
  headerRight: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
  },
  logo: {
    height: 70,
    width: 'auto',
    objectFit: 'contain' as const,
    display: 'block',
  },
  body: {
    padding: 0,
  },
  // Investmentstil stays full-width navy bar
  sectionBar: {
    background: NAVY,
    color: '#ffffff',
    fontFamily: TITLE_FONT,
    fontWeight: 700,
    fontSize: '14px',
    px: 10,
    py: 5,
  },
  sectionBody: {
    background: CONTENT_GRAY,
    px: 10,
    py: 8,
    mb: 12,
  },
  // PDF body is 8.5pt (~11px). Must not use MUI Typography body1 (theme forces 20px at sm+).
  investmentStyle: {
    fontSize: '11px',
    lineHeight: 1.35,
    color: '#222',
    whiteSpace: 'pre-wrap' as const,
  },
  // 50/50 main content grid
  columns: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 10,
    alignItems: 'start',
  },
  column: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: 8,
  },
  // Grey data section: title bar #D8D8D8 + container #F2F2F2
  // Sizes mirror PDF (pt→px ≈ 8pt→10 / 9.5pt→12). Use Box, not Typography (theme body1 → 20px).
  greySection: {
    background: CONTENT_GRAY,
    border: '1px solid #E2E2E2',
  },
  greySectionTitle: {
    background: SECTION_TITLE_GRAY,
    color: '#111',
    fontFamily: 'Georgia, "Times New Roman", serif',
    fontWeight: 700,
    fontSize: '12px',
    px: 8,
    py: 3,
    borderBottom: '1px solid #000',
  },
  greySectionBody: {
    px: 8,
    py: 4,
  },
  greySectionBodyComfort: {
    px: 8,
    py: 6,
  },
  kvRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 8,
    py: 2,
  },
  kvLabel: {
    color: '#333',
    fontSize: '10px',
    flex: '0 1 38%',
    minWidth: 0,
    lineHeight: 1.35,
  },
  kvValue: {
    fontWeight: 400,
    fontSize: '10px',
    textAlign: 'right' as const,
    flex: '1 1 58%',
    minWidth: 0,
    whiteSpace: 'pre-line' as const,
    lineHeight: 1.35,
  },
  allocRow: {
    display: 'flex',
    justifyContent: 'space-between',
    py: 2,
    fontSize: '10px',
  },
  allocRowComfort: {
    display: 'flex',
    justifyContent: 'space-between',
    py: 3.5,
    fontSize: '10px',
  },
  perfRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 0.42fr)',
    columnGap: 10,
    alignItems: 'start',
    py: 3,
    fontSize: '10px',
  },
  perfLabel: {
    color: '#333',
    minWidth: 0,
    lineHeight: 1.4,
    fontSize: '10px',
  },
  perfHead: {
    textAlign: 'right' as const,
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: 1.35,
  },
  perfValue: {
    textAlign: 'right' as const,
    fontWeight: 700,
    whiteSpace: 'nowrap' as const,
    lineHeight: 1.4,
    fontSize: '10px',
  },
  historyNote: {
    fontSize: '10px',
    color: '#333',
    textAlign: 'justify' as const,
    mb: 8,
    whiteSpace: 'pre-wrap' as const,
    lineHeight: 1.4,
  },
  chartBox: {
    mt: 8,
  },
  chartPlaceholder: {
    height: 180,
    background: 'repeating-linear-gradient(135deg, #e5e7eb, #e5e7eb 8px, #f3f4f6 8px, #f3f4f6 16px)',
  },
  chartCaption: {
    fontSize: '9px',
    color: '#666',
    mt: 6,
  },
  footnotes: {
    mt: 8,
  },
  footnote: {
    fontSize: '7px',
    color: '#222',
    lineHeight: 1.25,
  },
  disclaimer: {
    fontSize: '7px',
    color: '#222',
    textAlign: 'justify' as const,
    whiteSpace: 'pre-wrap' as const,
    mt: 5,
    lineHeight: 1.25,
  },
};

export default styles;
